import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Vue from 'vue';
import uuid from 'uuid';
import NotificationComponent from './notification.vue.js';
import { isVNode, getTopZindex } from '../../utils/dom.js';

const NotificationConstructor = Vue.extend(NotificationComponent);
const NOTIFICATION_DEFAULTS = {
  duration: 5000,
  position: 'top-right',
  offset: 0,
  title: undefined,
  message: undefined,
  type: undefined,
  showClose: true,
  onClose: null,
  customClass: '',
  dangerouslyUseHTMLString: false
};
let instance;
const instances = [];
const Notification = function (config) {
  const options = _objectSpread2(_objectSpread2({}, NOTIFICATION_DEFAULTS), config);
  const userOnClose = options.onClose;
  const id = `notification_${uuid()}`;
  options.onClose = function () {
    Notification.close(id, userOnClose);
  };
  instance = new NotificationConstructor({
    data: options
  });
  if (isVNode(options.message)) {
    instance.$slots.default = [options.message];
    options.message = 'REPLACED_BY_VNODE';
  }
  instance.id = id;
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.visible = true;
  instance.dom = instance.$el;
  const baseZindex = 2001;
  const topZindex = getTopZindex() + 1;
  instance.dom.style.zIndex = Math.max(topZindex, baseZindex);
  let verticalOffset = options.offset;
  instances.filter(item => item.position === options.position).forEach(item => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  verticalOffset += 16;
  instance.verticalOffset = verticalOffset;
  instances.push(instance);
  return instance;
};
['success', 'warning', 'info', 'error'].forEach(type => {
  Notification[type] = options => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options
      };
    }
    options.type = type;
    return Notification(options);
  };
});
Notification.close = function (id, userOnClose) {
  let index = -1;
  const len = instances.length;
  const instance = instances.filter((instance, i) => {
    if (instance.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!instance) {
    return;
  }
  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }
  instances.splice(index, 1);
  if (len <= 1) {
    return;
  }
  const removedHeight = instance.dom.offsetHeight;
  for (let i = index; i < len - 1; i++) {
    if (instances[i].position === instance.position) {
      const verticalProperty = instance.position.includes('top') ? 'top' : 'bottom';
      const newOffset = parseInt(instances[i].dom.style[verticalProperty], 10) - removedHeight - 16;
      instances[i].dom.style[verticalProperty] = `${newOffset}px`;
    }
  }
};
Notification.closeAll = function () {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};
var PendoNotification = Notification;

export { PendoNotification as default };
//# sourceMappingURL=pendo-notification.js.map
